var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.userInfo.type==3&&!_vm.isGroup)?_c('RoomCalendar'):_vm._e(),(_vm.userInfo.type==2&&!_vm.isGroup)?_c('Findhotel'):_vm._e(),(_vm.isAdmin)?_c('AdminHome'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }